// Centralized wrappers around Rust/WASM functions.

import init, {
  parse_fasta_to_json,
  complement,
  find_approx_matches_wasm,
  find_orfs_wasm,
  reverse_complement, // provided by Rust
} from "./pkg/Xromosome.js";

let _initPromise = null;
export function ensureWasm() {
  if (!_initPromise) _initPromise = init();
  return _initPromise;
}

// ---- Sync helpers (assume ensureWasm() ran) ----
export function parseFastaToJsonSync(text) {
  const jsonStr = parse_fasta_to_json(text);
  return JSON.parse(jsonStr);
}
export function complementSync(sequence) {
  return complement(sequence);
}
export function reverseComplementSync(sequence) {
  return reverse_complement(sequence);
}

// ---- Async helpers ----
export async function findApproxMatches(haystack, needle, maxMismatches = 0) {
  await ensureWasm();
  return find_approx_matches_wasm(haystack, needle, maxMismatches) || [];
}

/**
 * Find ORFs on BOTH strands.
 * IMPORTANT: Rust returns end as EXCLUSIVE. We keep it exclusive here.
 */
export async function findOrfsBothStrands(sequence) {
  await ensureWasm();
  const N = sequence.length;

  // Forward (top) strand
  const fwdRaw = find_orfs_wasm(sequence) || [];
  const fwd = fwdRaw.map((r) => ({
    frame: r?.frame ?? 0,
    start: r?.start ?? 0,
    endExcl: r?.end ?? 0, // exclusive
  }));

  // Reverse (bottom) strand via reverse complement
  const rc = reverse_complement(sequence) || "";
  const revRaw = rc ? find_orfs_wasm(rc) || [] : [];
  // Map [s,e) in RC back to original as [N-e, N-s)
  const rev = revRaw.map((r) => ({
    frame: (r?.frame ?? 0) + 3, // tag as reverse frames 3..5
    start: N - (r?.end ?? 0),
    endExcl: N - (r?.start ?? 0), // exclusive
  }));

  return [...fwd, ...rev];
}

// Convenience async wrappers
export async function parseFastaToJson(text) {
  await ensureWasm();
  return parseFastaToJsonSync(text);
}
export async function complementAsync(sequence) {
  await ensureWasm();
  return complementSync(sequence);
}
export async function reverseComplementAsync(sequence) {
  await ensureWasm();
  return reverseComplementSync(sequence);
}
